import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core";
import React, { useState } from "react";
import { api } from "./api/client";
import IconButton from "@mui/material/IconButton";
import { WorkHistory } from "@mui/icons-material";

const DURUMLAR = [
    { value: "Taslak", label: "Taslak" },
    { value: "Final", label: "Final" },
    { value: "Devam", label: "Devam Eden" },
    { value: "Pasif Devam", label: "Pasif Devam Eden" },
    { value: "Tamamlandi", label: "Tamamlanan" },
];

function hataMesaji(error) {
    const body = error?.response?.data;
    const detail = body?.error?.details?.[0]?.msg || body?.error?.message || body?.detail;
    if (typeof detail === "string" && detail) return detail;
    return "Durum güncellenemedi";
}

export default function ModalBoxDurum(props) {
    const [open, setOpen] = useState(false);
    const [durum, setDurum] = useState("");
    const [hata, setHata] = useState("");
    const [kaydediliyor, setKaydediliyor] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setHata("");
    };

    const guncelle = async () => {
        if (!durum) {
            setHata("Önce bir durum seçin");
            return;
        }
        if (!window.confirm("İş emri durumunu güncellemek istediğinize emin misiniz?")) {
            return;
        }
        setKaydediliyor(true);
        setHata("");
        try {
            await api.post("/is-emirleri/" + props.id + "/durum?id=" + props.id, { durum });
            handleClose();
            window.location.reload();
        } catch (error) {
            setHata(hataMesaji(error));
        } finally {
            setKaydediliyor(false);
        }
    };

    return (
        <div>
            <IconButton size="small" color="success" onClick={() => setOpen(true)} aria-label="Durum değiştir">
                <WorkHistory />
            </IconButton>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth>
                <DialogTitle id="form-dialog-title">İş Emri Durum Değiştir</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <strong>Müşteri: </strong>{props.musteri}<br />
                        <strong>İş Emri No: </strong>{props.is_emri_no}<br />
                        Lütfen durum seçiniz
                    </DialogContentText>
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="durum-sec-label">Durum Seç</InputLabel>
                        <Select
                            labelId="durum-sec-label"
                            value={durum}
                            onChange={(event) => {
                                setDurum(event.target.value);
                                setHata("");
                            }}
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                transformOrigin: { vertical: "top", horizontal: "left" },
                            }}
                        >
                            {DURUMLAR.map((item) => (
                                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {hata ? <p style={{ color: "#c62828", margin: "8px 0 0" }}>{hata}</p> : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">İptal</Button>
                    <Button onClick={guncelle} color="primary" disabled={kaydediliyor}>
                        {kaydediliyor ? "Kaydediliyor…" : "Durum Güncelle"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
